import { render, staticRenderFns } from "./Falcons.vue?vue&type=template&id=1a7cf87a&scoped=true&"
import script from "./Falcons.vue?vue&type=script&lang=js&"
export * from "./Falcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7cf87a",
  null
  
)

export default component.exports